import { render } from "./CollectView.vue?vue&type=template&id=b12e5028&scoped=true"
import script from "./CollectView.vue?vue&type=script&lang=js"
export * from "./CollectView.vue?vue&type=script&lang=js"

import "./CollectView.vue?vue&type=style&index=0&id=b12e5028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12e5028"]])

export default __exports__